import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=9f19671a&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=9f19671a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f19671a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f19671a')) {
      api.createRecord('9f19671a', component.options)
    } else {
      api.reload('9f19671a', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=9f19671a&scoped=true", function () {
      api.rerender('9f19671a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/notice.vue"
export default component.exports